import React from "react";
import "./Vademecum.css";
import bgImage from "../assets/images/cover-video-vademecum-scaled.jpg";
import personalCareIcon from "../assets/icons/ico-cuidado-personal.png";
import MedicamentosIcon from "../assets/icons/ico-Medicamentos.png";
import MovilidadIcon from "../assets/icons/ico-movilidad.png";
import NaturalsIcon from "../assets/icons/ico-naturals.png";

const Vademecum = () => {
  return (
    <>
      {/* HERO IMAGE */}
      <section
        className="vademecum-hero"
        style={{ backgroundImage: `url(${bgImage})` }}
      />

      {/* CONTENT */}
      <section className="vademecum-content">
        <div className="vademecum-container">
          {/* LEFT CONTENT */}
          <div className="vademecum-left">
            <h1>
              <span className="green">The most</span>
              <br />
              <span className="olive">comprehensive</span>
              <br />
              <span className="olive">vademecum</span>
            </h1>

            <p className="subtitle">
              We offer accessible and quality solutions for comprehensive
              healthcare
            </p>
          </div>

          {/* RIGHT CONTENT */}
          <div className="vademecum-right">
            <p className="bold">
              Cinfa is the company with the largest number of treatments in the
              Spanish pharmaceutical sector:
            </p>

            <p>
              <strong>1,500 presentations</strong> and{" "}
              <strong>+200 active ingredients</strong>. With leading brands in
              the various categories
            </p>
          </div>
        </div>
      </section>
      {/* CATEGORY SECTION */}
<section className="vademecum-categories">
  <div className="vademecum-cat-container">

    {/* CARD 1 */}
    <div className="vademecum-card green-border">
      <h3 className="cat-title green">Medicines</h3>

      <div className="cat-icon">
        <img src={MedicamentosIcon} alt="Medicines" />
      </div>

      <p className="cat-text">
        Leaders in the Spanish prescription medicine market. We also have a
        broad range of non-prescription drugs for all kinds of pathologies.
      </p>

      <div className="cat-image cat-image-medicines"></div>
    </div>

    {/* CARD 2 */}
    <div className="vademecum-card purple-border">
      <h3 className="cat-title purple">Personal care</h3>

      <div className="cat-icon">
        <img src={personalCareIcon} alt="Personal care" />
      </div>

      <p className="cat-text">
        Batterjee is the first laboratory in the self-care market at Spanish
        pharmacies. With ranges for skin pharmacy, eye care and podology…
      </p>

      <div className="cat-image cat-image-care"></div>
    </div>
    {/* CARD 3 */}
    <div className="vademecum-card purple-border">
      <h3 className="cat-title purple">Mobility</h3>

      <div className="cat-icon">
        <img src={MovilidadIcon} alt="Mobility" />
      </div>

      <p className="cat-text">
        We lead the Spanish orthopaedic market at pharmacies and orthopaedic specialists. Our Farmalastic and Orliman brands have histories that span decades.
      </p>

      <div className="cat-image cat-image-mobility"></div>
    </div>

    {/* CARD 4 */}
    <div className="vademecum-card purple-border">
      <h3 className="cat-title purple">Naturals</h3>

      <div className="cat-icon">
        <img src={NaturalsIcon} alt="Naturals" />
      </div>

      <p className="cat-text">
       We work in the field of prevention through nutrition and science-based solutions of natural origin.
      </p>

      <div className="cat-image cat-image-naturals"></div>
    </div>

  </div>
</section>

    </>
  );
};

export default Vademecum;
